import Image from '@tiptap/extension-image';

export default Image;
